
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.55 26.38a3 3 0 110 6h-5.39","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M35.76 20.4a3 3 0 010 6h-5.6","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12.16 17.4c0-.8 4.08-3.59 7.25-6.3 3.37-2.88 4.91-9.44 5.76-9.44 1.65 0 2.76.92 3 3 .42 3.59-1 7.77-3 9.76h10.38a3 3 0 110 6h-5.39M33.35 32.36a3 3 0 110 6H18.14a6 6 0 01-6-6","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.25 13.75h10.9v24.59H1.25z"}})])
          )
        }
      }
    